import ProgressBar from "@pathwright/ui/src/components/progress/ProgressBar"
import "./PathStatus.css"

const PathStatus = ({ permissions, progress }) => (
  <div className="PathStatus">
    {permissions && permissions.can_access && !isNaN(progress) ? (
      <ProgressBar
        className="PathStatus__progress"
        progress={progress}
        inverted={true}
      />
    ) : undefined}
  </div>
)

PathStatus.displayName = "PathStatus"

export default PathStatus
